import React, { useEffect, Children } from 'react';
import { Link } from 'react-router-dom';
export function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white min-h-screen" data-id="element-152">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 space-y-20" data-id="element-153">
        {/* Intro Section */}
        <section data-id="element-154">
          <h1 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-6" data-id="element-155">
            About The Good Father Project
          </h1>
          <p className="text-xl text-[#5a3a28] leading-relaxed" data-id="element-156">
            The Good Father Project is a community initiative that honors
            fathers and father-figures through the words of their children. It
            began as a simple idea that recognizing the quiet, steady work of
            fatherhood could strengthen families and communities.
          </p>
        </section>

        {/* What the Project Is */}
        <section data-id="element-157">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-158">
            What the Project Is
          </h2>
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed mb-8" data-id="element-159">
            At its heart, The Good Father Project invites children to write
            essays about the fathers and father-figures who matter most to them.
            These essays are shared, celebrated, and honored at community events
            as an act of gratitude and connection.
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-160">
            <div className="relative" data-id="element-161">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-162"></div>
              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-163">
                <img src="https://cdn.magicpatterns.com/uploads/6Ym5vZu4XnCm6QbFtUYqye/493815572_9374528642659468_7603856205039483468_n.jpg" alt="Children on bicycles reading essays posted on a community wall" className="w-full h-full object-cover" data-id="element-164" />
              </div>
            </div>
            <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-165">
              Children reading essays honoring fathers and father-figures at a
              community display.
            </p>
          </div>
        </section>

        {/* Our Story / Where It Began */}
        <section data-id="element-166">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-167">
            Where It Began
          </h2>
          <div className="space-y-6 text-lg text-[#5a3a28]/90 leading-relaxed" data-id="element-168">
            <p data-id="element-169">
              The Good Father Project was first launched in Mongolia during{' '}
              <a href="https://travishellstrom.com/goodfatherproject" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-170">
                Peace Corps service
              </a>
              . Known locally as Сайн Аав Төсөл (Sain Aav Tosol), it grew from
              conversations with families, teachers, and community members about
              the role of fathers in children's lives.
            </p>
            <div className="flex flex-col items-center gap-3" data-id="element-171">
              <div className="relative" data-id="element-172">
                <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-173"></div>
                <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-174">
                  <img src="https://cdn.magicpatterns.com/uploads/oXBvEyUu6hJFD7SUtWtY5J/4534377.jpg" alt="A grandfather holding his young grandson, both smiling, in Mongolia" className="w-full h-full object-cover" data-id="element-175" />
                </div>
              </div>
              <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-176">
                A grandfather and his grandson in Mongolia, where The Good
                Father Project first began.
              </p>
            </div>
            <p data-id="element-177">
              On International Children's Day, fathers and father-figures were
              honored in a public celebration - a moment of recognition that
              resonated deeply across the community. The project emerged through
              relationships, listening, and shared values: a belief that
              honoring fathers could be a quiet but powerful act of community
              building.
            </p>
          </div>
        </section>

        {/* Video Section */}
        <section className="my-12" data-id="element-178">
          <div className="rounded-xl overflow-hidden shadow-lg border border-[#ecdfd2] bg-[#ecdfd2]/20" data-id="element-179">
            <div className="aspect-video w-full" data-id="element-180">
              <iframe className="w-full h-full" src="https://www.youtube.com/embed/POBzwObdprI" title="The Good Father Project - Peace Corps Mongolia" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-181"></iframe>
            </div>
            <div className="p-4 text-center" data-id="element-182">
              <p className="text-sm text-[#5a3a28]/70 italic" data-id="element-183">
                This video reflects the early roots and inspiration of The Good
                Father Project during Peace Corps service in Mongolia.
              </p>
            </div>
          </div>
        </section>

        {/* Bringing It Home */}
        <section data-id="element-184">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3b2316] mb-4" data-id="element-185">
            Bringing It Home
          </h2>
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed mb-8" data-id="element-186">
            The values at the center of The Good Father Project - gratitude,
            presence, and community - are not unique to any one culture. They
            resonate everywhere. That's why we've brought the project to
            Harrisonburg and Rockingham County, Virginia, where fathers and
            father-figures are being recognized through essay celebrations and
            community events like the{' '}
            <a href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-187">
              Best Weekend Ever
            </a>
            . Honoring fathers matters across cultures and communities. It
            strengthens the bonds between children and the adults who care for
            them, and it reminds us all of the importance of showing up.
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-188">
            <div className="relative" data-id="element-189">
              <div className="absolute inset-0 rounded-full bg-[#d4956a]/20 blur-2xl scale-110" data-id="element-190"></div>
              <div className="relative w-56 h-56 md:w-64 md:h-64 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-191">
                <img src="https://cdn.magicpatterns.com/uploads/4o3KhNiRrq9YxLmuLcSFEr/BWE_FULLSET250-118.jpg.webp" alt="Families enjoying The Best Weekend Ever in Downtown Harrisonburg" className="w-full h-full object-cover" data-id="element-192" />
              </div>
            </div>
            <p className="text-sm text-[#5a3a28]/70 italic text-center mt-2" data-id="element-193">
              The Best Weekend Ever in Downtown Harrisonburg.
            </p>
          </div>
        </section>

        {/* Closing */}
        <section className="border-t border-[#ecdfd2] pt-12 mt-12" data-id="element-194">
          <p className="text-lg text-[#5a3a28]/90 leading-relaxed" data-id="element-195">
            The Good Father Project continues to grow through the care of our
            community. Each essay written, each father honored, each partner
            that joins adds to something meaningful. We're grateful to everyone
            who has been part of this journey, and we look forward to what comes
            next.
          </p>
          <div className="mt-6" data-id="element-196">
            <Link to="/#partner" className="text-[#c06a2b] hover:text-[#3b2316] transition-colors text-sm font-medium" data-id="element-197">
              Partner With Us →
            </Link>
          </div>
        </section>
      </div>
    </main>;
}